import React from "react";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import "./CommunityService.css";
import GbrFormsComponent from "../GBRForms/GbrFormsComponent";

// Exporting the CommunityService functional component
export default function CommunityService() {
  return (
    <>
      {/* Header Section */}
      <HeaderComponent />

      {/* Updates Banner for Community Service */}
      <UpdatesBanner
        className="communityService"
        bannerText="Community Service"
      />

      {/* Component showing different services*/}
      <GbrFormsComponent />

      {/* Footer Section */}
      <FooterComponent />
    </>
  );
}

